<unit>{{'kg' | lang}}</unit>
